import { cloneDeep } from '@/utils/common';
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { Module } from 'vuex';
import gemMeterState from '@/modules/gem-meter/store/state';
import { GemMeterState } from '@/modules/gem-meter/types/types';
import { RootState } from '@/store';

export * from './actions';
export * from './mutations';
export * from './getters';

export default function (): Module<GemMeterState, RootState> {
  return {
    namespaced: true,
    state: cloneDeep(gemMeterState) as GemMeterState,
    mutations,
    getters,
    actions,
  };
}
